import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const EmptyText = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-slate);
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 36px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 900px) and (min-width: 641px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 1px 4px var(--vo-escuro-8);
  border: 1px solid var(--vo-cloud);
  display: flex;
  align-items: center;
  gap: 12px;
`

const IconBox = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--vo-cobalto), var(--vo-capri));
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const ShieldSvg = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
)

const Info = styled.div``

const Name = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: var(--vo-ink);
  margin: 0 0 4px;
`

const getMaturityStyle = (label) => {
  if (!label) return { color: 'var(--vo-slate)', bg: 'var(--vo-slate-10)' }
  const l = label.toLowerCase()
  if (l.includes('l3') || l.includes('defined') || l.includes('definido')) return { color: 'var(--vo-success)', bg: 'var(--vo-success-10)' }
  if (l.includes('l4') || l.includes('l5') || l.includes('managed') || l.includes('optimized')) return { color: 'var(--vo-success)', bg: 'var(--vo-success-10)' }
  if (l.includes('l2') || l.includes('developing') || l.includes('gerenciado')) return { color: 'var(--vo-celeste)', bg: 'var(--vo-info-10)' }
  if (l.includes('l1') || l.includes('initial') || l.includes('inicial')) return { color: 'var(--vo-warning)', bg: 'var(--vo-warning-10)' }
  return { color: 'var(--vo-celeste)', bg: 'var(--vo-info-10)' }
}

const MaturityBadge = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
  padding: 2px 8px;
  border-radius: 20px;
  display: inline-block;
`

export const FrameworkBadges = ({ badges = [] }) => {
  const { t } = useTranslation('transparency')
  if (!badges || badges.length === 0) {
    return <EmptyText>{t('public.emptyFrameworks')}</EmptyText>
  }

  return (
    <Grid>
      {badges.map((badge, index) => {
        const style = getMaturityStyle(badge.maturityLabel)
        return (
          <Card key={badge.frameworkId || index}>
            <IconBox>
              <ShieldSvg />
            </IconBox>
            <Info>
              <Name>{badge.name}</Name>
              {badge.maturityLabel && (
                <MaturityBadge $color={style.color} $bg={style.bg}>{badge.maturityLabel}</MaturityBadge>
              )}
            </Info>
          </Card>
        )
      })}
    </Grid>
  )
}

FrameworkBadges.propTypes = {
  badges: PropTypes.array,
}
